import { useParams, useLocation } from "react-router-dom";
import styles from "./Header.module.css";
import { useFeatureFlipStore } from "Store/featureFlipStore";
import { useUpdateFeatureDetails } from "API/Queries/useUpdateFeatureDetails";

const Header = () => {
  const setIsFeatureEnabled = useFeatureFlipStore((s) => s.setIsFeatureEnabled);
  const isFeatureEnabled = useFeatureFlipStore((s) => s.isFeatureEnabled);
  const isFeatureDynamic = useFeatureFlipStore((s) => s.isFeatureDynamic);
  const { id, featureId } = useParams();
  const { state } = useLocation();
  const featureName = (state as { name: string })?.name;
  const { mutate: updateFeatureDetails } = useUpdateFeatureDetails();

  const handleClick = () => {
    updateFeatureDetails(
      {
        projectId: id as string,
        featureId: featureId as string,
        enabled: !isFeatureEnabled,
        dynamic: isFeatureDynamic,
      },
      {
        onSuccess: () => {
          setIsFeatureEnabled(!isFeatureEnabled);
        },
      }
    );
  };

  return (
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <h1 className={styles.title}>Feature: {featureName}</h1>
      </div>
      <div className={styles.controls}>
        <div className={styles.toggleWrapper}>
          <label className={styles.toggleLabel}>Enabled</label>
          <button
            className={`${styles.toggleButton} ${
              isFeatureEnabled ? styles.enabled : ""
            }`}
            onClick={handleClick}
            aria-label="Toggle feature"
          >
            <div className={styles.toggleSlider} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
